import { render, staticRenderFns } from "./PageDescriptionManager.vue?vue&type=template&id=4739636a"
import script from "./PageDescriptionManager.vue?vue&type=script&lang=js"
export * from "./PageDescriptionManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports